module.exports = require('./lib/Observable.js').Observable;



//////////////////
// WEBPACK FOOTER
// ../app_shared/~/apollo-link-context/~/zen-observable/index.js
// module id = 572
// module chunks = 1